// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HELP_FORM_ACK_EMAIL = "\u010eakujeme za spr\u00e1vu. Sleduj svoj email.";
export const HELP_FORM_ACK_INTERNAL_MAIL = "\u010eakujeme za spr\u00e1vu. Sleduj svoju intern\u00fa po\u0161tu.";
